import React from 'react'

type Props = {
  children: React.ReactNode
}

type State = {
  error?: Error
}

const reloadStorageKey = 'skolanalys.chunk-load-reload'
const reloadCooldownMs = 60 * 1000

const isChunkLoadError = (error: Error) => {
  const message = error.message || ''

  return (
    error.name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Unexpected token')
  )
}

export default class ChunkLoadErrorBoundary extends React.Component<Props, State> {
  state: State = {}

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (!isChunkLoadError(error)) {
      console.error(error, errorInfo)
      return
    }

    const now = Date.now()
    const lastReload = Number(sessionStorage.getItem(reloadStorageKey) || 0)

    if (now - lastReload > reloadCooldownMs) {
      sessionStorage.setItem(reloadStorageKey, String(now))
      window.location.reload()
    }
  }

  render() {
    if (!this.state.error) return this.props.children

    if (isChunkLoadError(this.state.error)) {
      return (
        <div role="alert">
          Sidan har uppdaterats. Ladda om sidan for att hamta den senaste versionen.
          <button type="button" onClick={() => window.location.reload()}>
            Ladda om
          </button>
        </div>
      )
    }

    throw this.state.error
  }
}
